// extracted by mini-css-extract-plugin
export default {"unAuthContainer":"unauthorized_unAuthContainer__yM1zN"};